import React from 'react';

class SubMenu extends React.Component {
	static getRoutes() {
	}
	render() {
		return (
			<ul className="sub-menu">
        {
        	this.props.children
        }
      </ul>
		)
	}
}

export default SubMenu;


// WEBPACK FOOTER //
// ./src/components/menu/SubMenu.jsx